export default __webpack_public_path__ + "assets/1e94a2d7476706cef2547b9c34abd0f9.svg";